import type { CSSProperties } from 'react';

interface PageLoaderProps {
  label?: string;
  /** ページのルートに渡すテーマ変数（useThemeVars の戻り値） */
  style?: CSSProperties;
}

/**
 * ページ全体の読み込み中表示（フルスクリーン中央寄せ）。
 * 各ページで重複していた「min-h-screen 中央寄せ＋大きめスピナー」を共通化する。
 */
export default function PageLoader({ label = '読み込み中...', style }: PageLoaderProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center" style={style}>
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-[color:var(--theme-primary)] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-gray-600">{label}</p>
      </div>
    </div>
  );
}